export default "__VITE_ASSET__Dkk65gTZ__"